import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation, Link } from 'react-router-dom';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import Lenis from 'lenis';
import 'lenis/dist/lenis.css';
import '@/App.css';
import { SiteLayout } from './components/SiteLayout';
import { Toaster } from './components/ui/sonner';
import Home from './pages/Home';
import Services from './pages/Services';
import Pricing from './pages/Pricing';
import Gallery from './pages/Gallery';
import About from './pages/About';
import Contact from './pages/Contact';
import Franchise from './pages/Franchise';
import Referral from './pages/Referral';

function RoutedSite() {
  const { pathname } = useLocation();
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ autoRaf: true, duration: 1.05, smoothWheel: true, anchors: { offset: -90 } });
    return () => lenis.destroy();
  }, [reduced]);
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    const title = pathname === '/' ? 'Care Beyond The Shine' : pathname.slice(1).replace(/^./, c => c.toUpperCase());
    document.title = `${title} | Znta Auto Spa™`;
  }, [pathname]);
  return <SiteLayout><Routes><Route path="/" element={<Home/>}/><Route path="/services" element={<Services/>}/><Route path="/pricing" element={<Pricing/>}/><Route path="/gallery" element={<Gallery/>}/><Route path="/about" element={<About/>}/><Route path="/franchise" element={<Franchise/>}/><Route path="/referral" element={<Referral/>}/><Route path="/contact" element={<Contact/>}/><Route path="*" element={<section className="wrap not-found"><span className="eyebrow">404 / A LITTLE OFF ROUTE</span><h1>LET’S GET YOU<br/>BACK ON THE ROAD.</h1><Link className="action-button" to="/" data-testid="not-found-home">Back to home</Link></section>}/></Routes></SiteLayout>;
}

export default function App() {
  return <MotionConfig reducedMotion="user"><BrowserRouter><RoutedSite/></BrowserRouter><Toaster position="bottom-left" theme="dark" richColors/></MotionConfig>;
}

